import React, { useEffect, useState, useCallback } from "react";
import { useDispatch } from "react-redux";
import Sidebar from "../../components/Sidebar";
import TopBar from "../../components/TopBar";
import IMAGES from "../../../../constant/images";
import { Button } from "antd";
import MemberCounter from "../../components/MemberCounter";
import MemberControl from "../../components/MemberControl";
import MemberTable from "../../components/MemberTable";
import ExportModal from "../../components/shared/ExportModal";
import useIsMobile from "../../components/shared/Mobile-Responsive";
import { getClientMemberListApi } from "../../../../redux/action/Client-Member";

// Mapping stat card IDs to API filter values
const STAT_TO_FILTER_MAP = {
  'total': 'all',
  'highModerate': 'high_moderate_risk'
};

export default function Index() {
  const [collapsed, setCollapsed] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [sortConfig, setSortConfig] = useState({ field: "name", order: "asc" });
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedStatId, setSelectedStatId] = useState(null);

  const [filters, setFilters] = useState({
    gender: null,
    riskStatus: null,
    startDate: null,
    endDate: null,
  });

  const [exportModalVisible, setExportModalVisible] = useState(false);
  const [selectedExportFormat, setSelectedExportFormat] = useState(null);
  const [exportData, setExportData] = useState([]);
  const [visibleData, setVisibleData] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);

  const dispatch = useDispatch();
  const isMobile = useIsMobile();

  // Handle stat card click for filtering
  const handleStatCardClick = useCallback((statId) => {
    if (selectedStatId === statId) {
      // Deselect if clicking the same stat
      setSelectedStatId(null);
      setFilters(prev => ({ ...prev, riskStatus: null }));
      // Call API with no risk filter
      dispatch(getClientMemberListApi({
        page: 0,
        size: 5000,
        riskStatus: undefined
      }));
    } else {
      // Select new stat and apply filter
      setSelectedStatId(statId);
      const filterValue = STAT_TO_FILTER_MAP[statId];

      if (filterValue === 'all') {
        setFilters(prev => ({ ...prev, riskStatus: null }));
        // Call API with no risk filter
        dispatch(getClientMemberListApi({
          page: 0,
          size: 5000,
          riskStatus: undefined
        }));
      } else if (filterValue === 'high_moderate_risk') {
        setFilters(prev => ({ ...prev, riskStatus: 'HIGH_RISK,MODERATE_RISK' }));
        // Call API with both HIGH_RISK and MODERATE_RISK
        dispatch(getClientMemberListApi({
          page: 0,
          size: 5000,
          riskStatus: 'HIGH_RISK,MODERATE_RISK'
        }));
      }
    }
    setCurrentPage(1); // Reset to first page when filtering
  }, [selectedStatId, dispatch]);

  const handleExportClick = () => {
    setExportModalVisible(true);
  };

  const handleCloseModal = () => {
    setExportModalVisible(false);
    setSelectedExportFormat(null);
  };

  const handleExportData = (format) => {
    if (format) {
      setSelectedExportFormat(format);
      alert(`Exporting data as ${format}`);
    } else {
      alert(`Exporting data as ${selectedExportFormat || "default format"}`);
    }
    setExportModalVisible(false);
  };

  return (
    <div className="fixed inset-x-0 bottom-0 top-16 flex bg-[#F8FAFC] overflow-hidden">
      <TopBar />

      {/* Sidebar */}
      <div
        className={`hidden lg:flex ${collapsed ? "w-[64px]" : "w-[272px]"} fixed top-0 left-0 h-screen z-20`}
      >
        <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} />
      </div>
      {/* Main Content */}
      <div
        className={`flex-1 min-w-0 overflow-auto bg-[#F8FAFC] pt-2 px-2 pb-8 transition-all duration-300 ${
          collapsed ? "lg:ml-[64px]" : "lg:ml-[272px]"
        }`}
      >
        <div className="p-4 md:p-6 bg-[#FFFFFF] min-h-screen rounded-2xl">
          {/* Header */}
          {isMobile ? (
            <>
             <div className="flex items-center justify-between gap-2 p-2">
          <h1 className="text-xl font-bold text-[#171717] font-poppins mb-0">Members</h1>

          <div className="flex items-center gap-2">
            <Button
              onClick={handleExportClick}
              className="flex items-center gap-2 h-9 px-[14px] bg-white text-[#171717] text-[13px] font-semibold border-[1px] border-solid border-[#E2E8F0] rounded-xl shadow-sm hover:bg-[#F8FAFC] transition hover:text-[#171717]"
            >
              Export
              <img src={IMAGES.export_icon} alt="export_icon" className="w-[16px]" />
            </Button>

            <Button
              onClick={() => (window.location.href = "/add-member")}
              className="btn-gradient flex items-center justify-center h-9 px-[10px] rounded-xl border-0"
            >
              <img src={IMAGES.create_followup} alt="add_icon" className="w-[16px]" />
            </Button>
          </div>
        </div>
            </>
          ):(
            <>
             <div className="w-full mx-auto p-2 mb-1">
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
              <h1 className="text-xl font-bold text-[#171717] font-poppins mb-0">Members</h1>

              <div className="flex gap-2">
                <Button
                  onClick={handleExportClick}
                  className="flex items-center gap-2 h-9 px-[14px] bg-white text-[#171717] text-[13px] font-semibold border-[1px] border-solid border-[#E2E8F0] rounded-xl shadow-sm hover:bg-[#F8FAFC] transition hover:text-[#171717]"
                >
                  Export
                  <img src={IMAGES.export_icon} alt="export_icon" className="w-[16px]" />
                </Button>

                <Button
                  onClick={() => (window.location.href = "/add-member")}
                  type="primary"
                  className="btn-gradient flex items-center gap-2 h-9 px-[14px] text-[13px] font-semibold border-0 rounded-xl"
                >
                  <img src={IMAGES.create_followup} alt="export_icon" className="w-[16px]" />
                  Add Member
                </Button>
              </div>
            </div>
          </div>
            </>
          )}


          <div className="flex flex-col lg:flex-row gap-3 p-2">
            <div className="flex-1">
              <MemberCounter
                onStatClick={handleStatCardClick}
                selectedStatId={selectedStatId}
              />
            </div>
          </div>

          <MemberControl
            selectedType={"All Members"}
            onSearchChange={(value) => {
              setSearchTerm(value);
              setCurrentPage(1);
            }}
            onSortChange={setSortConfig}
            filters={filters}
            setFilters={setFilters}
            setCurrentPage={setCurrentPage}
             selectedRows={selectedRows}
  setSelectedRows={setSelectedRows}
  exportData={exportData} 
  setExportData={setExportData}
          />

          <div className="border-t-[1px] border-solid border-x-0 border-b-0 border-[#F1F5F9] mt-0 mb-1" />

          <MemberTable
            searchTerm={searchTerm}
            sortConfig={sortConfig}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            onSortChange={setSortConfig}
            filters={filters}
            onSelectedRowsChange={(rows) => setSelectedRows(rows)} 
            setExportData={setExportData} 
            setVisibleData={setVisibleData}
            selectedRows={selectedRows} 
          />
        </div>
      </div>

      {/* Include the ExportModal component here */}
      <ExportModal
        visible={exportModalVisible}
        onClose={handleCloseModal}
        onExport={handleExportData}
        selectedRows={selectedRows} 
        data={visibleData} 
        allData={exportData} 
      />
    </div>
  );
}
